import React, { useState } from "react";
import { AddButton, CancelButton, CloseButton } from "../../button/Button";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import commonstyles from "../Forms.module.css";
import styles from "./AddField.module.css";

const COLUMN_OPTIONS = ["Column 1", "Column 2", "Column 3"];

export default function AddField({ onClose }) {
  const [fieldName, setFieldName] = useState("");
  const [mapColumn, setMapColumn] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Added Field:", { fieldName, mapColumn });
    setFieldName("");
    setMapColumn("");
    if (onClose) onClose();
  };

  return (
    <div className={commonstyles.backdrop}>
      <form
        onSubmit={handleSubmit}
        className={`${commonstyles.container} ${commonstyles.smallContainer} ${styles.container}`}
      >
        <div className={commonstyles.header}>
          <h2 className={styles.heading}>Add Field</h2>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.content}>
          <p className={styles.description}>Add new field details below.</p>

          <div className={styles.fieldGroup}>
            <label className={styles.label}>
              <span className={styles.required}>*</span>Field Name
            </label>
            <input
              type="text"
              value={fieldName}
              onChange={(e) => setFieldName(e.target.value)}
              placeholder="Type Name"
              className={commonstyles.input}
              style={{ paddingRight: "12px" }}
              required
            />
          </div>

          <CustomDropdown
            label="Select Field"
            required={true}
            value={mapColumn}
            onChange={setMapColumn}
            options={COLUMN_OPTIONS}
            placeholder="Map Column"
          />
        </div>

        <div className={commonstyles.footer}>
          <CancelButton onClick={onClose} />
          <AddButton onClick={onClose} />
        </div>
      </form>
    </div>
  );
}
